<template>
  <div class="col-12">
    <form class="book-form">
      <div class="columns">
        <fieldset class="username">
          <input
            type="text"
            @input="formError = ''"
            placeholder="Username*"
            v-model="username"
            required
          />
        </fieldset>
        <fieldset class="email">
          <input
            type="email"
            @input="formError = ''"
            placeholder="Email*"
            v-model="email"
            required
          />
        </fieldset>
        <fieldset class="phone">
          <input
            type="text"
            placeholder="Phone*"
            v-model="phone"
            @input="
              phone = phone.replace(/[^0-9+]/g, '');
              formError = '';
            "
            required
          />
        </fieldset>
      </div>
      <fieldset class="message">
        <textarea
          placeholder="Your Message*"
          rows="2"
          @input="formError = ''"
          v-model="message"
          required
        ></textarea>
      </fieldset>
      <div v-if="formError" class="error-message">
        {{ formError }}
      </div>
      <!-- Success -->
      <div v-if="formSuccess" style="color: #EFBED4; font-size: 20px;">
        {{ formSuccess }}
      </div>
      <div class="bot">
        <a
          class="button-two-line m-auto"
          style="text-transform: uppercase"
          type="submit"
          @click.prevent="submitFranchise"
          >{{ $t("send_a_message") }}</a
        >
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "FranchiseComponent",
  data() {
    return {
      langStore,

      // form fields
      username: "",
      email: "",
      phone: "",
      message: "",
      formError: "",
      formSuccess: "",
    };
  },

  methods: {
    submitFranchise() {
      // Clear previous messages
      this.formError = "";
      this.formSuccess = "";

      if (
        !this.username ||
        !this.email ||
        !this.phone ||
        !this.message
      ) {
        this.formError = "Please fill all required fields.";
        return;
      }
      const payload = {
        username: this.username,
        email: this.email,
        phone: this.phone,
        message: this.message,
      };

      axios
        .post(`${process.env.VUE_APP_BASE_URL}/api/question`, payload)
        .then(() => {
          this.formSuccess = "Your request has been sent successfully!";

          // clear form fields
          this.username = "";
          this.email = "";
          this.phone = "";
          this.message = "";
        })
        .catch((err) => {
          console.error("Error sending question:", err);
          this.formError = "Something went wrong. Please try again.";
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.error-message {
  color: #ff3b3b;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 900;
}

.success-message {
  color: #2ecc71;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 900;
}
</style>
